<template>
  <div>

    <div>
      <div class="vuse-content-wrapper mt-4">
        <v-row >
          <v-col cols="12" md="6" class="mt-0">
            <h2 class="ml-3 float-left">
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="xmlReport">
                      <ExcelIcon />
                    </v-btn>
                  </template>
                  <span>Download Table as CSV</span>
                </v-tooltip>
              </span>
              <span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="loadData">
                      <v-icon>sync</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
              </span>
             {{$t(page+'.Localization')}}
            </h2>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right pr-4">
              <v-tooltip top>
                <template v-slot:activator="{ on }">     
                  <v-btn icon color="warning" v-on="on" @click="rebuildTranslationsFiles">
                    <v-icon>fas fa-skull-crossbones</v-icon>
                  </v-btn>
                </template>
                <span>{{$t(page+'.Rebuild All Translations files')}}</span>
              </v-tooltip>
          </v-col>
        </v-row>
        <!--<v-row v-if="!orders">
          <no-data />  
        </v-row>-->

        <v-row class="mt-0">
          <v-col cols="12" class="mt-2">
            <v-card class="neu-glow pb-4">
              <v-card-title>
                <v-col cols=12 sm="6" lg="11" >
                  <v-btn-toggle v-model="selectedTable" active-class="success" @change="refreshData">
                    <v-btn x-small :color="table.name.includes('Boss')?'info':''" v-for="table in files" :key="table.name" class="mr-1" :value="table.name">
                      <v-icon left :color="table.fix?'secondary':'primary'">{{table.fix?'fas fa-exclamation-circle':'fas fa-check-square'}}</v-icon>
                      {{table.name.replace('Boss','Boss_')}}
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols=12 sm="6" lg="1">
                  <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                      style="max-width:150px"
                  ></v-text-field>
                  <v-btn x-small block :loading="saving" :disabled="changedFlag==0" class="mt-2" dark color="warning" @click="save">
                    <v-icon color="success" left>fas fa-save</v-icon>{{$t(page+'.Save')}}
                  </v-btn>
                  <v-btn class="mt-1" x-small block color="success"  @click="addSentence_dialog=1">
                    <v-icon left>fas fa-plus-square</v-icon>{{$t(page+'.Add')}}
                  </v-btn>
                </v-col>
              </v-card-title>
              <v-data-table
                  dense
                  v-model="selectedSentence"
                  fixed-header="true"
                  :headers="i18_headers"
                  :items="sentences"
                  :items-per-page="Math.floor((wIH - 419-59)/2.1)"
                  :height="wIH - 419"
                  :search="search"
                  multi-sort
                  class="elevation-1 mx-4"
                  :loading="sentences.length==0" 
                  :loading-text="$t(page+'.Loading... Please wait')"
                  :no-data-text="$t(page+'.Please select a Table')"
                  :no-results-text="$t(page+'.No Record matching search parameters')"
                >

                    <template v-slot:item.en="{ item }">
                      <v-text-field hide-details tabindex="1" :filled="item.en!=undefined&&item.en.includes('***')?'info':''" :background-color="item.en!=undefined&&item.en.includes('***')?'#ff000020':''" outlined class="slim py-1" dense name="en" @keyup="edit(item,'en',item.en)" v-model="item.en" :value="item.en"></v-text-field>
                    </template>
                    <template v-slot:item.it="{ item }">
                      <v-text-field hide-details tabindex="2" :filled="item.it!=undefined&&item.it.includes('***')?'info':''" :background-color="item.it!=undefined&&item.it.includes('***')?'#ff000020':''" outlined class="slim py-2" dense name="it" @keyup="edit(item,'it',item.it)" v-model="item.it" :value="item.it"></v-text-field>
                    </template>

                    <template v-slot:item.zh="{ item }">
                      <v-text-field hide-details tabindex="3" :filled="item.zh!=undefined&&item.zh.includes('***')?'info':''" :background-color="item.zh!=undefined&&item.zh.includes('***')?'#ff000020':''" outlined class="slim py-2" dense name="zh" @keyup="edit(item,'zh',item.zh)" v-model="item.zh" :value="item.zh"></v-text-field>
                    </template>

              </v-data-table>
            </v-card>
          </v-col>
        </v-row>        
      </div>
    </div>
    <v-dialog v-model="addSentence_dialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Add Sentence')}}</v-card-title
        >
        <v-row class="mx-5">
          <v-col md="12" cols="12">
            {{$t(page+'.Enter new sentence almost in English')}}
          </v-col>  
          <v-col md="12" cols="12">
            <v-text-field
                color="primary"
                :label="$t(page+'.In English')"
                v-model="newItem.en"
                :hint="$t(page+'.Enter sentence in English')"
                persistent-hint
                name="en"
                class="mt-0"
                outlined
                dense
                background-color="#ff000020"
            ></v-text-field>
          </v-col>  
          <v-col md="12" cols="12">
            <v-text-field
                color="primary"
                :label="$t(page+'.In Italian')"
                v-model="newItem.it"
                :hint="$t(page+'.Enter Translation in Italian if possible')"
                persistent-hint
                name="it"
                class="mt-0"
                outlined
                dense
            ></v-text-field>
          </v-col>  
          <v-col md="12" cols="12">
            <v-text-field
                color="primary"
                :label="$t(page+'.In Chinese')"
                v-model="newItem.zh"
                :hint="$t(page+'.Enter Translation in Chinese if possible')"
                persistent-hint
                name="zh"
                class="mt-0"
                outlined
                dense
            ></v-text-field>
          </v-col>  
        </v-row>
        <v-card-actions>
          <v-btn color=""  @click="addSentence_dialog=false">
            {{$t(page+'.Abort')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="addSentence">
            {{$t(page+'.Save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      bottom
      :color="snackbar_color"
      :timeout="snackbar_timeout"
      style="z-index:20001;"
    >
    {{$t(page+'.'+snackbar_message)}}
    </v-snackbar>
  </div>
</template>
<style scoped>
  .bordered::before{
    border-color:transparent;
    border: 6px solid green!important;
  }
  .bottomborder::before{
    border-color:transparent;
    border-bottom: 8px solid blue!important;
  }
  .wrapped{
    height:60px!important;
    border-style:none!important;
  }
  .v-btn:before{
    background-color: inherit!important;
  }
  .v-btn--active:before{
    opacity:1!important;
  }
  .v-btn__content{
    display:block!important;
    }
  .v-btn-vertical{
    flex-direction: column!important;
  }
  .v-btn-toggle {
    display:block!important;
  }
  .slim .v-input__slot {
    min-height:30px!important;
    max-height:20px!important;
    margin-bottom:1px!important;
  } 
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";

import _ from 'lodash'
export default {
  components: { NoData, SkeletonRevenue, ExcelIcon},
  computed : {
    ...mapGetters(["user","settings"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
  },    
  data() {
    return {
      namespace: "Reports",
      page: "BossLocalize",
      files:[],
      sentences: [],
      selectedTable:'BossUsers',
      loading: true,
      snackbar:false,
      search: '',
      changed:{},
      changedFlag:0,
      saving:false,
      errorid: null,
      newItem:{},
      addSentence_dialog:false,
      wIH:window.innerHeight,
      headers: [
          { text: 'English', value: 'en',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Italian', value: 'it',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'},
          { text: 'Chinese', value: 'zh',align: 'start', class : 'text-subtitle-1 font-weight-black primary--text py-4'}
      ],
    };
  },
  created(){
    this.loadData('BossUsers')
  },
  deactivated() {
    console.log(188,'deactivated');
    this.snackbar=true;
  },
  beforeDestroy() {
      console.log(192);
      if (Object.keys(this.changed).length>0)
      {
        this.save();
      }
      this.snackbar=true;
  },
  methods:
  {
    rebuildTranslationsFiles(){
      let url='https://admin.xlogistics.it/ajax/boss/localize_build_tables.php';
      window.location.href = url;
      //this.$router.push({ name: url })
    },
    addSentence()
    {
      console.log(289,JSON.stringify(this.sentences))
      this.sentences.unshift(this.newItem);
      this.newItem={};
      this.changedFlag=1;
      console.log(292,JSON.stringify(this.sentences))
      this.addSentence_dialog=false;
    },
    save(){
      console.log(198,this.selectedTable);
      console.log(199,this.sentences);
      console.log(200,this.changed);
      let files={};
      let pl={};
      this.saving=true;
      Object.keys(this.changed).forEach(lang => {
        console.log(202,lang);
        /*
        //let rs=this.sentences.map(x => Object.keys(x).filter((key) => key.includes(lang)).reduce((cur, key) => { return Object.assign(cur, { [key]: x[key] })}, {}))
        let rs=this.sentences.map(x => Object.keys(x).filter((key) => key.includes(lang)).reduce((cur, key) => { return x[key] }, {}))
        let rs2=JSON.stringify(rs);
        console.log(206,rs2);
        files[lang]=rs;
        */
       Object.keys(this.changed).forEach(lang => {
          this.sentences.forEach(x => {
            pl[x.id]=x[lang];
          })
          files[lang]=JSON.parse(JSON.stringify(pl));
          //for (let el in payload) delete payload[el];
        });
      });
      let json=JSON.stringify(files);
      console.log(212,json);
      console.log(212,files);

      //let payload={"action":"edit_translations","filename":this.selectedTable,"payload":json,"pl":files};
      let payload={"action":"edit_translations","filename":this.selectedTable,"payload":json};
      let rslt=this.update_db(payload);
      console.log(232,rslt);
      this.saving=false;

      for (let el in this.changed) delete this.changed[el];
      console.log(214,this.changed);
      this.changedFlag=Object.keys(this.changed).length;

    },
    edit(item,lang,t){
      this.changed[lang]=true;
      this.changedFlag=Object.keys(this.changed).length;
      console.log(216,Object.keys(this.changed).length,this.changedFlag);
      console.log(217,lang,item.en,t,this.selectedTable,this.changed)
    },
    refreshData(){
      //save data!!
      if (Object.keys(this.changed).length>0)
      {
        this.snackbar=true;
      }
      else
      {
       console.log(167,this.selectedTable);
        this.loadData(this.selectedTable);
      }
    },
    async xmlReport(){
      let payload={"timeframe":this.timeframe.toString(),"sellers":this.activeeBayAccounts.toString()};
      window.location.href='/ajax/reports/revenue_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(table='BossUsers'){
      this.loading=true;
      try{
          const payload={"action":"localize","table":table}
          const res = await this.$http.post('/boss/localize.php', payload );
          console.log(179,res)          
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.sentences=res.data.payload.translations;
              this.files=res.data.payload.files;
              console.log(185,res.data.payload,this.sentences)
              this.loading= false;
            break;

            case '0001':

            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading=false;

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
      this.loading= false;
    },
    async update_db(payload){
      let jwt=sessionStorage.getItem('jwt');
      try{
          console.log(199,payload);
          
          const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,'payload':payload});
          console.log(202,res.data);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(417,res.data.message);
              console.log(418,res.data.payload[res.data.payload.field]);
              //console.log(252,payload.id,res.data.payload,this.isJson(res.data.payload),this.customers)
              /*if (res.data.payload!='0')
              {
                this.customers.unshift(JSON.parse(res.data.payload));
                console.log(254,this.customers);
              }*/
             break;
          }
          return res.data;
      } 
      catch(e)
      {
        console.log(e);
          this.snackbar_color='red darken-2';
          this.snackbar_text='Connection Error - Try Later';
      }
      this.snackbar=true;
      return null;
    },
  },
};
</script>
<!--<style scoped>
.theme--light.v-messages{
  display:none;
}
</style>-->